import styled from 'styled-components';

export const Container = styled.div`
  &.Wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    height: 250px;
    width: 350px;
    padding: 20px;
    //overflow: hidden;
  }
  &.DoShadow{
    background: #FFFFFF;
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    border-radius: 10px;
  }
  &.HoverAccount{
    position: relative;
    margin-bottom: 10px;
  }
  &.HoverAccount:hover > .DoShadow{
    background: rgb(221,228,247);
  }
  &.HoverAccount:hover .DotsToSee{
    display: block;
  }
  &.DotsToSee{
    position: absolute;
    top: 20px;
    right: 15px;
  }
`;

export const StyledLink = styled.a`
  width: 60px;
  border: none;
  height: 60px;
  opacity:1;
  background: #fff;
  border-radius: 8px;
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 136%;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover{
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    text-decoration: none;
    color: #FFFFFF;
  }
  &:focus{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    text-decoration: none;
    color: #FFFFFF;
  }
  &:active{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    text-decoration: none;
    color: #FFFFFF;
  }
`;
export const StyledSpan = styled.span`
  font-family: 'Courier New', Courier, monospace;
  font-size: 60px;
  line-height: 60px;
  color: rgb(0,127,246);
`;

export const StyledParagraph = styled.div`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 164%;
  text-align: center;
  color: #2C2B48;
`;

export const NameContainer = styled.div`
  //overflow: hidden;
  display: flex;
  width: 100%;
  justify-content: center;
`

export const IndexingText = styled.p`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 164%;
  text-align: center;
  margin-bottom: 0;
  color: #2C2B48;
`

export const AccountName = styled.div`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 164%;
  text-align: center;
  color: #2C2B48;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`